import { css } from "styled-components";

const helveticaNeueCyrFonts = [
  {
    name: "Thin",
    weight: 100,
  },
  {
    name: "UltraLight",
    weight: 200,
  },
  {
    name: "Light",
    weight: 300,
  },
  {
    name: "Regular",
    weight: 400,
  },
  {
    name: "Medium",
    weight: 500,
  },
  {
    name: "Bold",
    weight: 700,
  },
  {
    name: "ExtraBold",
    weight: 800,
  },
  {
    name: "Black",
    weight: 900,
  },
];

const helveticaNeueCyrFontFaces = helveticaNeueCyrFonts.map(
  (font) => css`
    @font-face {
      font-family: "HelveticaNeueCyr";
      font-weight: ${font.weight};
      src: url(${require(`../../../static/fonts/HelveticaNeueCyr/HelveticaNeueCyr-${font.name}.woff2`)})
          format("woff2"),
        url(${require(`../../../static/fonts/HelveticaNeueCyr/HelveticaNeueCyr-${font.name}.woff`)})
          format("woff"),
        url(${require(`../../../static/fonts/HelveticaNeueCyr/HelveticaNeueCyr-${font.name}.ttf`)})
          format("truetype");
    }
  `
);

export default helveticaNeueCyrFontFaces;
